import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class LoaderService {
    public estadoMostrarLoader: Observable<boolean>;
    public usarOcultarTimeout = true;

    private _estadoLoader = new Subject<boolean>();
    private usarLoader = true;

    constructor() {
        this.estadoMostrarLoader = this._estadoLoader;
    }

    public mostrarLoader() {
        this._estadoLoader.next(this.usarLoader);
        this.usarLoader = true;
    }

    public ocultarLoader() {
        this._estadoLoader.next(false);
    }

    public noUsarLoader() {
        this.usarLoader = false;
    }
}
